export enum PulsesConstants {
  SET_PULSECAROTID = 'pulses/SET_PULSECAROTID',
  SET_PULSERADL = 'pulses/SET_PULSERADL',
  SET_PULSEBRAL = 'pulses/SET_PULSEBRAL',
  SET_PULSEFEML = 'pulses/SET_PULSEFEML',
  SET_PULSEDORSL = 'pulses/SET_PULSEDORSL',
  SET_PULSECAROTIDR = 'pulses/SET_PULSECAROTIDR',
  SET_PULSERADR = 'pulses/SET_PULSERADR',
  SET_PULSEBRAR = 'pulses/SET_PULSEBRAR',
  SET_PULSEFEMR = 'pulses/SET_PULSEFEMR',
  SET_PULSEDORSR = 'pulses/SET_PULSEDORSR',

  SET_RESPONSE = 'pulses/SET_RESPONSE',
  SAVE_PULSES = 'pulses/SAVE_PULSES',
  RESET_STATE = 'pulses/RESET_STATE',
  SET_PULSES = 'pulses/SET_PULSES',
}
